
import './App.css';
import RouteComponent from './RouteComponent';

function App() {
  return (
    <RouteComponent />
  );
}

export default App;
